export interface AgentResponseMetadata {
  timestamp: string;
  session_id: string;
  internal_operation: string;
  internal_status: string;
}

export interface AgentResponseData {
  tipo: string;
  reason?: string;
  chat_text: string;
  metadata: AgentResponseMetadata;
}

export interface AgentResponse {
  data: AgentResponseData;
  operation: string;
  status: string;
  path: string;
}

// Helper function to check if response is an error
export const isAgentResponseError = (response: AgentResponse): boolean => {
  return response.data.tipo === "erro" || response.status === "error";
};

// Helper function to extract chat text
export const extractChatText = (response: AgentResponse): string => {
  return response.data.chat_text || "No response received";
};

// Helper function to extract session ID
export const extractSessionId = (response: AgentResponse): string => {
  return response.data.metadata.session_id;
};
